import { useId } from "react";

import { Error, InputBlock, InputElement, InputGroup, Label, MaskedInputElement } from "./style";

const Input = ({
  value,
  onChange = () => null,
  onBlur = () => null,
  onClick = () => null,
  onFocus = () => null,
  type = "text",
  placeholder = null,
  required = false,
  mask = null,
  normalize = null,
  label = null,
  touched = false,
  error = null,
  success = false,
  disabled,
  translate = "no",
  id,
  ...rest
}) => {
  const generatedId = useId();
  const inputId = id || `input-${generatedId}`;
  const errorId = `${inputId}-error`;

  // FE-26: ошибка показывается только после того, как поле трогали
  const hasError = Boolean(touched && error);

  const handleChange = e => {
    if (normalize) {
      onChange(normalize(e.target.value));
    } else {
      onChange(e.target.value);
    }
  };

  // FE-26: поле связано с меткой и с текстом ошибки,
  // иначе скринридер озвучивает его как безымянное и валидное
  const fieldProps = {
    id: inputId,
    value,
    onChange: handleChange,
    placeholder,
    type,
    onBlur,
    onClick,
    onFocus,
    disabled,
    translate,
    // Валидацией владеет yup/Formik. Нативный required включил бы браузерные
    // пузыри поверх наших сообщений, поэтому только ARIA-семантика.
    "aria-required": required || undefined,
    "aria-invalid": hasError || undefined,
    "aria-describedby": hasError ? errorId : undefined,
    ...rest,
  };

  return (
    <InputGroup>
      <InputBlock isError={hasError} isSuccess={success}>
        {label && (
          <Label htmlFor={inputId} translate={translate}>
            {label} {required && <span aria-hidden="true">*</span>}
          </Label>
        )}
        {mask ? <MaskedInputElement {...fieldProps} mask={mask} /> : <InputElement {...fieldProps} />}
      </InputBlock>
      {/* FE-26: место под сообщение зарезервировано — форма не дёргается при появлении ошибки */}
      <Error id={errorId} role="alert" $visible={hasError}>
        {hasError ? error : null}
      </Error>
    </InputGroup>
  );
};

export default Input;
